import { ActionReducerMap } from '@ngrx/store';
import { JournalViewColumnViewModelStates } from '../states';
import * as fromColumn1ViewModelReducers from './column_1_view_model.reducers';
export const columnViewModelFeatureKey1 = 'genericDocJournalViewModel';
export const columnViewModelReducers1: ActionReducerMap<JournalViewColumnViewModelStates> = {
  column1ViewModel: fromColumn1ViewModelReducers.reducer,
};